import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight, Zap } from 'lucide-react';

const UpgradeNudge = ({ quota, variant = 'banner' }) => {
  if (!quota || quota.is_pro || quota.on_trial) return null;
  const used = quota.used_today || 0;
  const limit = quota.limit || 3;
  if (used < 2) return null; // only nudge from 2/3 onwards
  const reached = used >= limit;

  if (variant === 'card') {
    return (
      <div className="rounded-2xl bg-gradient-to-br from-orange-400 to-orange-500 text-white p-6 shadow-lg">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 mb-1"><Zap className="w-4 h-4" /><span className="text-xs font-bold uppercase tracking-widest">One more scan…</span></div>
            <h3 className="font-display text-2xl font-bold mb-1">{reached ? 'You’ve used all 3 free scans today' : `${limit - used} free scan${limit-used === 1 ? '' : 's'} left today`}</h3>
            <p className="text-white/90 text-sm">Upgrade to unlock unlimited photo scans, advanced analytics and the recipe library.</p>
          </div>
          <Link to="/pricing" className="shrink-0 bg-white text-orange-600 hover:bg-orange-50 rounded-full px-5 py-2.5 font-semibold text-sm inline-flex items-center gap-1">Upgrade <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl bg-orange-50 border border-orange-200 p-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-orange-100 text-orange-600 grid place-items-center"><Sparkles className="w-5 h-5" /></div>
        <div>
          <p className="font-display font-bold text-emerald-950">{reached ? 'Free limit reached for today' : `${limit - used} of ${limit} free scans left`}</p>
          <p className="text-emerald-950/60 text-sm">Go unlimited from just $5.99/week — 1-day free trial.</p>
        </div>
      </div>
      <Link to="/pricing" className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-4 py-2 text-sm font-semibold inline-flex items-center gap-1 shrink-0">Upgrade <ArrowRight className="w-3.5 h-3.5" /></Link>
    </div>
  );
};

export default UpgradeNudge;
